import EditIcon from '@mui/icons-material/Edit';
import { Card, CardContent, CardHeader, IconButton, Typography } from "@mui/material";
import * as React from "react";
import CircularProgress from '@mui/material/CircularProgress';
import { connect } from "react-redux";
import { UpdateResult } from '../../../models';
import { ApplicationState, actionCreators } from "../../../store";
import FetchHelper from '../../FetchHelper';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles } from '../../styles';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { formatDateTime } from '../../../utils';
import SelectChangeMeasurentStartEndDialog from '../../dialogs/SelectChangeMeasurentStartEndDialog';

const UPDATE_CHANGE_MEASUREMENT_START_END = "UPDATE_CHANGE_MEASUREMENT_START_END";

const params = {
    mainid: "",
    device_no: "",
    title:"",
    isRefreshAllBegin: 0,
    isEdit: false,
    setIsEdit: (isEdit: boolean) => { },
    setChangeMeasurentStartedEnd: (isEdit: boolean) => { },
    isDisbleUpdateBtn: true,
    measurementInfo: [] as any
}

export type ChangeMeasurentStartedEndProps = ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

export const ChangeMeasurentStartedEnd = (props: ChangeMeasurentStartedEndProps) => {
    const { mainid, device_no, title, isRefreshAllBegin, isEdit, isDisbleUpdateBtn, measurementInfo,
            setIsEdit, setChangeMeasurentStartedEnd, onUpdate, onUpdateSuccess, onUpdateError  } = props;
    const [openSelectDialog, setOpenSelectDialog] = React.useState(false);
    const [editFlg, setEditFlg] = React.useState(false);
    const [updateLoading, setUpdateLoading] = React.useState(false);
    const [isFetchAll, setIsFetchAll] = React.useState(false);
    const [showDoneIcon,setShowDoneIcon] = React.useState(false);
    const [showTimeExecute,setShowTimeExecute] =  React.useState<any>();

    React.useEffect(() => {
        if(measurementInfo){
            setShowTimeExecute(measurementInfo.find((item:any) => item.device_no == device_no)?.last_get_datetime);
        }
    },[measurementInfo])

    const refreshAll = () => {
        isRefreshAllBegin > 0 ? setIsFetchAll(true) : setIsFetchAll(false);
    }

    // eslint-disable-next-line
    React.useEffect(refreshAll, [isRefreshAllBegin]);

    React.useEffect(() => {
        setIsEdit(editFlg);
        // eslint-disable-next-line
    }, [editFlg]);

    React.useEffect(() => {
        setChangeMeasurentStartedEnd(updateLoading);
    })

    const handleEdit = () => {
        setOpenSelectDialog(true);
    };

    const handleUpdateOk = (request: any) => {
        setOpenSelectDialog(false);
        setUpdateLoading(true);
        onUpdate(device_no,request);
    };

    const handleUpdateCancel = () => {
        setOpenSelectDialog(false);
        setEditFlg(false);
    };

    const handleUpdateSuccess = (success: boolean, data: any, error: any) => {
        const result = {
            mainid: data.mainid,
            resultCode: data.result_code,
        } as UpdateResult;
        if (result.resultCode === '0') {
            onUpdateSuccess(title);
            setUpdateLoading(false);
            setEditFlg(false);
            setShowDoneIcon(true);
            setShowTimeExecute(formatDateTime(new Date()))
        } else {
            handleUpdateError(success, data, error);
        }
    }

    const handleUpdateError = (success: boolean, data: any, error: any) => {
        onUpdateError(title);
        setUpdateLoading(false);
        setEditFlg(false);
        setShowDoneIcon(false);
    }    

    return (
        <>
            <Card style={{ marginBottom:"12px", backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={showDoneIcon ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            <IconButton aria-label="edit" onClick={() => handleEdit()} disabled={isDisbleUpdateBtn || isEdit || updateLoading || isFetchAll}>
                                <EditIcon fontSize="medium" style={isDisbleUpdateBtn || isEdit || updateLoading || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                            
                        </div>
                    }
                    title={title}
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0',height:'50px' }}>
                    {updateLoading ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <div style={{ position: 'absolute', top: '10%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終実行日時：{showTimeExecute}</Typography>
                    )}
                </CardContent>
            </Card >
            {
                openSelectDialog && 
                    <SelectChangeMeasurentStartEndDialog
                        device_no={device_no}
                        isOpen={true}
                        onOK={(data:any) => handleUpdateOk(data)}
                        onCancel={handleUpdateCancel}
                        mainId={mainid}
                    />
            }
            <FetchHelper fetchId={UPDATE_CHANGE_MEASUREMENT_START_END + `${device_no}`} method="POST" onComplete={(success, data, error) => success ? handleUpdateSuccess(success, data, error) : handleUpdateError(success, data, error)} />
        </>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
});

const mapDispatchToProps = {
    onUpdate: (device_no: any,data: any) => actionCreators.fetch(UPDATE_CHANGE_MEASUREMENT_START_END + `${device_no}`, `/polling/set?code=PY`, 'POST', data, false, true),
    onUpdateSuccess: (title:string) =>
        actionCreators.showMessage({
            type: "info",
            title: `${title}`,
            body: `${title}変更新しました。`,
        }),
    onUpdateError: (title:string) =>
        actionCreators.showMessage({
            type: "error",
            title: `${title}`,
            body: `${title}を変更できませんでした。`,
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChangeMeasurentStartedEnd);



